import React from 'react'
import { Steps } from 'antd'
import { useKaraoke } from 'hooks/karaoke'

export const BuildSteps = () => {
  const { currentStep } = useKaraoke()
  return (
    <Steps current={currentStep}>
      <Steps.Step title="Add lyrics" />
      <Steps.Step title="Sync lyrics" />
      <Steps.Step title="Preview" />
      <Steps.Step title="Upload" />
    </Steps>
  )
}
